var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"Widget",attrs:{"id":"widget"}},[_c('Header'),_c('div',{staticClass:"chat-log"},[_c('Chats')],1),(_vm.style === 'survey')?_c('Progress'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }